var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#50AF95;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.5,157.3L171.5,157.3c-1.2,0.1-7.4,0.5-21.2,0.5c-11,0-18.8-0.3-21.6-0.5l0,0c-42.5-1.9-74.2-9.3-74.2-18.1 c0-8.9,31.7-16.2,74.2-18.2v28.9c2.8,0.2,10.7,0.7,21.7,0.7c13.2,0,19.8-0.6,21-0.7V121c42.4,1.9,74.1,9.3,74.1,18.1 S213.9,155.4,171.5,157.3L171.5,157.3L171.5,157.3z M171.5,118.1V92.2h59.2V52.7H69.5v39.4h59.2V118c-48.1,2.2-84.3,11.7-84.3,23.2 s36.2,20.9,84.3,23.2v82.9h42.8v-82.9c48-2.2,84.1-11.7,84.1-23.1S219.5,120.3,171.5,118.1L171.5,118.1L171.5,118.1z M171.5,118.1 L171.5,118.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.1a023d37ce6f66ff42e28808a9bea910.svg";
export { ForwardRef as ReactComponent };